import React from 'react';

import PropTypes from 'prop-types';
import { Download } from '@tds/core-interactive-icon';
import Heading from '@tds/core-heading';
import DimpleDivider from '@tds/core-dimple-divider';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import request from '../../../utils/request';
import Attachements from './attachements';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const {
  contentfulValues: { no: noEnglish }
} = EN;

const {
  contentfulValues: { no: noFrench }
} = FR;

const OrderAttachments = ({ links, orderData, hideQuote }) => {
  const localizedString = useLocalizedStringsContext();
  const {
    ORDERS: { quotePdf, contractUnSigned, contractSignedPdf, attachments },
    productInOrderForOptions: { esChat }
  } = localizedString;
  const profile = request.getProfile();
  const uploadAttachementAvailable = profile && [].includes(profile.role_id);
  const isLinkAvailable = profile && [1, 2, 7, 11].includes(profile.role_id);

  const { productInOrderFor, msaEContractBA, channelName } = orderData;

  const isTQChannel = channelName === 'TQ';

  const isSendContractAllowedWithTQ =
    isTQChannel ||
    (productInOrderFor === esChat &&
      (msaEContractBA === noEnglish || msaEContractBA === noFrench));

  const getRow = (name, label) =>
    links[name] ? (
      <li
        className="list-group-item"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div>{label}</div>
        <div>
          <Download
            onClick={() => window.open(links[name], '_blank')}
            a11yText="Download"
          />
        </div>
      </li>
    ) : null;

  const linkSignedPdf =
    isLinkAvailable && getRow('contractSignedPdf', contractSignedPdf);

  return (
    <>
      <>
        <DimpleDivider />
        <Heading level="h2" tag="h4">
          {attachments}
        </Heading>
        <DimpleDivider />
        {isSendContractAllowedWithTQ && (
          <div className="card">
            <div className="card-header">
              <Heading level="h4">{`${
                !hideQuote ? `Quote/Contract pdf` : `Contract pdf`
              }`}</Heading>
            </div>
            <ul className="list-group list-group-flush">
              {!hideQuote && getRow('quotePdf', quotePdf)}
              {getRow('contractUnSigned', contractUnSigned) &&
                getRow('contractUnSigned', contractUnSigned)}
              {linkSignedPdf && linkSignedPdf}
            </ul>
          </div>
        )}
        <Attachements
          isUploadAvailable={uploadAttachementAvailable}
          orderData={orderData}
        />
      </>
    </>
  );
};

OrderAttachments.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      quotePdf: PropTypes.string,
      contractUnSigned: PropTypes.string,
      contractSignedPdf: PropTypes.string
    })
  ).isRequired,
  hideQuote: PropTypes.bool.isRequired
};

export default OrderAttachments;
